import { useEffect, useState } from "react";
import { uniqueBy } from "utils/Utils";
import EnumDesignation from "utils/enum/EnumDesignation";

export const FILTER_REVISION_VALUES = [
  {
    id: -2,
    name: "All",
  },
  {
    id: -1,
    name: "Active",
  },
];

export const FILTER_ALL = "all";
export const FILTER_LAST = "last";

const EXCLUDE_FILES = [
  EnumDesignation.TABLES,
  EnumDesignation.FIGURE_PDF,
  EnumDesignation.FIGURE,
  EnumDesignation.POWERPOINTER_PRESENTATION,
  EnumDesignation.ADDITIONAL_FILE,
  EnumDesignation.VIDEO_FILE,
];

export const useEditorFiles = ({ files, visible }: any) => {
  const [filesFilter, setFilesFilter] = useState<any>([]);
  const [revisionOption, setRevisionOption] = useState<any>(FILTER_REVISION_VALUES);
  const [revisionSelectedOption, setRevisionSelectedOption] = useState<any>(FILTER_REVISION_VALUES[1]);
  const [filesToogle, setFilesToogle] = useState<string>(FILTER_LAST);

  useEffect(() => {
    if (visible && files?.length > 0) {
      const uniqueArrayRevision: any = files
        .map((f: any) => f.revision)
        .filter((value: number, index: number, self: any) => self.indexOf(value) === index);
      const revisionOptionNew: any = [];
      revisionOptionNew.push(...FILTER_REVISION_VALUES);
      uniqueArrayRevision.forEach((revision: number) => {
        revisionOptionNew.push({
          id: revision,
          name: revision.toString(),
        });
      });
      setRevisionOption(revisionOptionNew);

      let filesNew = files;
      if (revisionSelectedOption) {
        // active
        if (revisionSelectedOption?.id === FILTER_REVISION_VALUES[1].id) {
          const uniqueByType = uniqueBy(files, "designation");
          const filesFilterNew: any = [];
          filesNew = filesNew?.filter((f: any) => uniqueByType.includes(f.designation));
          uniqueByType.forEach((uniqType: any) => {
            if (EXCLUDE_FILES.includes(uniqType)) {
              filesFilterNew.push(...filesNew?.filter((f: any) => f.designation === uniqType));
            } else {
              const maxRevisionByType = Math.max(
                ...filesNew.filter((f: any) => f.designation === uniqType).map((o: any) => o.revision)
              );
              const fileFindBy = files
                ?.sort((a: any, b: any) => b.uploadDate - a.uploadDate)
                ?.find((f: any) => f.designation === uniqType && f.revision === maxRevisionByType);
              filesFilterNew.push(fileFindBy);
            }
          });

          filesNew = filesFilterNew;

          // all
        } else {
          if (revisionSelectedOption?.id !== -2) {
            filesNew = filesNew?.filter((f: any) => f.revision === revisionSelectedOption?.id);
          }
          if (filesToogle === FILTER_LAST) {
            const filesFilterNew: any = [];
            const uniqueByType = uniqueBy(filesNew, "designation");
            uniqueByType.forEach((uniqType: any) => {
              if (EXCLUDE_FILES.includes(uniqType)) {
                filesFilterNew.push(...filesNew?.filter((f: any) => f.designation === uniqType));
              } else {
                const maxIdByType = Math.max(
                  ...filesNew.filter((f: any) => f.designation === uniqType).map((o: any) => o.id)
                );
                const filedFindBy = filesNew?.find((f: any) => f.designation === uniqType && f.id === maxIdByType);
                filesFilterNew.push(filedFindBy);
              }
            });
            filesNew = filesFilterNew;
          }
        }
      }
      setFilesFilter(filesNew.sort((a: any, b: any) => b.uploadDate - a.uploadDate));
    }
  }, [files, visible, revisionSelectedOption, filesToogle]);

  return {
    filesFilter,
    revisionOption,
    revisionSelectedOption,
    setRevisionSelectedOption,
    filesToogle,
    setFilesToogle,
  };
};
